// ---------------------------------------------------------------------------
// Base colors
// https://alixpartners.invisionapp.com/d/#/console/14628715/304196291/preview
// ---------------------------------------------------------------------------

export const white = '#FFFFFF';
export const black = '#333333';
export const black2 = '#1A1A1A';
export const grey2 = '#F2F2F2';

export const grey20 = '#FAFAFA'; // Equivalent to `darken(0.02, '#FFFFFF')`
export const grey30 = '#F7F7F7'; // Equivalent to `darken(0.03, '#F7F7F7')`
export const grey40 = '#F2F2F2';
export const grey50 = '#EEEEEE'; // Equivalent to `darken(0.066, '#FFFFFF')`
export const grey100 = '#EFEFEF';
export const grey150 = '#E6E6E6';
export const grey200 = '#CCCCCC'; // Equivalent to `darken(0.2, '#FFFFFF')`
export const grey400 = '#999999'; // Equivalent to `darken(0.4, '#FFFFFF')`
export const grey450 = '#979797'; // Equivalent to `darken(0.4, '#FFFFFF')`
export const grey500 = '#767676'; // Equivalent to `darken(0.537, '#FFFFFF')`
export const grey700 = '#4B4B4B'; // Equivalent to `darken(0.705, '#FFFFFF')`

export const greenDark = '#498829';
// export const green = '#519F3E';
export const greenLight = '#5CB247';
export const greenLight2 = '#5CB335';
export const greenLight3 = '#5AB246';
export const greenLight4 = '#BFE2B6';
export const greenLightest = '#F6FBF5';
export const greenLightest2 = '#EFF8ED';

export const red = '#E95959';
export const redBright = '#EE3A36';
export const redDark = '#BC1310';

export const orangeActive = '#FDE3C0';
export const chartPptBlack = '#000000';
export const chartPptBarBlue = '#0596A6';
export const chartPptBarLightBlue = '#77B0BE';
export const chartLightBlue = '#B0D7E8';
export const chartDarkBlue = '#8CA8B3';
export const chartBrightBrown = '#C78D6B';
export const chartDullBlue = '#6BABC7';
export const chartDullBlueDarker = '#4486A3';
export const chartOrange = '#F9A12A';
export const chartLightOrange = '#FFCA82';
export const chartJaffaOrange = '#F58430';
export const chartLightGray = '#F7F7F7';
export const chartDarkGray = '#737373';
export const lightestRed = '#FEEEEE';
export const chartTundoraGray = '#4D4D4D';
export const chartHippyBlue = '#5695B0';
export const bgGrey = '#F8F8F8';
export const hoverGreen = '#488929';
export const tailSpend = '#fff9f1';

export const chartSaturatedOrange = '#FF600F';
export const chartSaturatedBlue = '#032E45';
export const chartSaturatedLightBlue = '#C4E5EA';
export const chartSaturatedGreen = '#0696A6';
export const chartViolet = '#939DF3';

export const waterfallChartExportColors = {
	darkBlue: '#006176',
	blue: '#0596A6',
	lightBlue: '#77B0BE',
	lightestBlue: '#BBD7DE',
	orange: '#FF910D',
	lightOrange: '#FFCA82',
	grey: grey400,
	lightGrey: grey200,
};
// export const redDark = '#C34141';
// export const orange = '#FAA229';

// TODO: Define shades of blue
// #A7E2F6 // light
// #80D1EC
// #5AB7D5
// #4AAAC9
// #3C9EBE
// #2B92B4
// #1580A3
// #0C6D8D
// #005673 // dark

// ---------------------------------------------------------------------------
// TODO: To be removed
// ---------------------------------------------------------------------------

export const colorError = '#D0021B'; // TODO: use `red` instead
export const colorIsExplicit = '#F26022'; // TODO: use `orange` instead
export const brandColors = {
	green: '#5CB335', // TODO: use `green` or `greenLight` instead
};

// ---------------------------------------------------------------------------
// TODO: To be defined based on base colors
// ---------------------------------------------------------------------------

export const dataVizColors = {
	orange: '#FFB500',
	red: '#FF2F24',
};

export const leverColors = {
	default: '#DBDBDB',
	low: '#91D5DD',
	medium: '#0796A6',
	high: '#015963',
};

export const waveColors = {
	1: ['#5CB335', '#078F45', '#17723C'],
	2: ['#0796A6', '#006276', '#012E45'],
	3: ['#3646B0', '#233193', '#040C52'],
};

export const CHART_COLORS = [
	'#032E45',
	'#0696A6',
	'#ADAFB2',
	'#FF600F',
	'#15723B',
	'#77B0BE',
	'#006176',
	'#FF910F',
	'#008F0A',
	'#595959',
];
